export const localStorageKeys = {
  jwt: 'jwt',
} as const
